module.exports = __webpack_public_path__ + "img/solution-hudxil-system-pic-1.1d2614a1.png";